import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
import { HaProfileInfo } from '../models/HaProfileInfo.model';
import { Subscription } from 'rxjs';
import { TodayScheduleModel } from '../models/TodayScheduleModel.model';
import { ConflictedRecordModel } from '../models/ConflictedRecordModel.model';


@Injectable()
export class HaHeaderServiceService {

  //onSidebarClickedMobileView

  constructor(private http: HttpClient) { }
  invokeFirstComponentFunctionSidebarHA = new EventEmitter();
  subsVarHASidebar: Subscription;
  onSidebarClickedMobileViewHA(){
    this.invokeFirstComponentFunctionSidebarHA.emit();
  }

  getConflictedPatient(){
    return this.http.get(globalAdd.Paneladdress + 'api/HA/ImpExp/getConflictedResult');
  }

  saveConflictedPatient(conflictedPatients : ConflictedRecordModel[]){
    return this.http.post(globalAdd.Paneladdress + 'api/HA/ImpExp/SaveHandledConflictedRecord',conflictedPatients);
  }

  getDashboardData() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/home/getDashboardData');
  }

  changePassword(oldPwd: string, newPwd: string, rePwd: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Home/changeNewHaPassword', { oldPwd: oldPwd, newPwd: newPwd, rePwd: rePwd });
    // return this.http.get(globalAdd.Paneladdress + 'api/HA/Home/changeNewHaPassword?oldPwd='+ oldPwd+'&newPwd='+ newPwd+'&rePwd='+rePwd);
  }

    getTodaySchedule() {
      
        var totalDate = new TodayScheduleModel(new Date());
        return this.http.post(globalAdd.Paneladdress + 'api/HA/ScheduledPatient/getDoctorEventsByDate', totalDate);

    }

  getNotifications() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Home/getNotifications');
  }

  removeHaNotifications(notificationIds: any[]) {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Home/removeHaNotifications?notificationIds='+ notificationIds );
  }

  getProfileData() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/Home/getHaProfileInfo');
  }

  updateProfileInfo(profileModal: HaProfileInfo) {
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Home/updateProfileInfo',  profileModal);
  }

  uploadAdminPhoto(File: File) {
    const data: FormData = new FormData();
    data.append("Photo", File);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(globalAdd.Paneladdress + 'api/HA/Home/uploadPhoto', data, { headers, reportProgress: true, observe: 'events' });
  }

}
